import PageHeader from "common/components/PageHeader/PageHeader";
import Table from "common/components/Table/Table";
import Select from "common/components/Select/Select";
// import AlertsContext from 'common/contexts/alerts';
import useItem from "common/hooks/useItem";
import useList from "common/hooks/useList";
import ImageFromStrapiMedia from "common/components/ImageFromStrapiMedia/ImageFromStrapiMedia";
import React, {
  // eslint-disable-next-line comma-dangle
  useCallback,
  useEffect,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import TableAvatarTitle from "common/components/TableUtilities/TableAvatarTitle/TableAvatarTitle";
import {
  TableDeleteButton,
  TableRefusalButton,
  TableValidationButton,
} from "common/components/TableUtilities/TableButtons/TableButtons";
import StatusBadge from "common/components/StatusBadge/StatusBadge";

function UserDocuments() {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    setPageIndex,
    itemsPerPage,
    itemsCount,
    error,
    pageIndex,
    removeListItem,
  } = useList("user-documents", {
    defaultFilters: {},
    defaultSort: "",
    populate: ["user", "document"],
  });
  const { removeItem, updateItem } = useItem("user-documents", "");

  const status = useMemo(
    () => [
      {
        value: "refused",
        label: t("common.refused"),
      },
      {
        value: "in_waiting",
        label: t("common.in_waiting"),
      },
      {
        value: "accepted",
        label: t("common.accepted"),
      },
    ],
    [t]
  );

  const handleDelete = useCallback(
    async (id: any) => {
      removeListItem(id);
      await removeItem(id);
      fetchItems();
    },
    [removeListItem, fetchItems, removeItem]
  );

  const handleValidation = useCallback(
    async (item: any) => {
      const updatedItem = {
        ...item,
        validationDate: new Date().toISOString(),
        status: "accepted",
      };
      await updateItem(updatedItem.id, updatedItem);
      fetchItems();
    },
    [updateItem, fetchItems]
  );

  const handleRefusal = useCallback(
    async (item: any) => {
      const updatedItem = {
        ...item,
        refusalDate: new Date().toISOString(),
        status: "refused",
      };
      await updateItem(updatedItem.id, updatedItem);
      fetchItems();
    },
    [updateItem, fetchItems]
  );

  // const { setAlert } = useContext(AlertsContext);

  useEffect(() => {
    if (error) {
      // setAlert(error, 'danger');
    }
  }, [error /* setAlert */]);

  const columns = useMemo(
    () => [
      {
        Header: t("common.username"),
        filterName: "user][username$contains",
        className: "table-start",
        // eslint-disable-next-line react/no-unstable-nested-components
        Cell: ({
          row: {
            original: { user },
          },
        }: any) => (
          <TableAvatarTitle
            title={user?.username}
            link="#"
            secondTitle={user?.username}
          />
        ),
      },
      {
        Header: t("common.type"),
        className: "table-start",
        // eslint-disable-next-line react/no-unstable-nested-components
        Cell: ({
          row: {
            original: { isLicense, isID },
          },
        }: any) => (
          <span>
            {isLicense
              ? t("document.license")
              : isID
              ? t("document.identification")
              : ""}
          </span>
        ),
      },
      {
        Header: t("common.document"),
        className: "table-start",
        // eslint-disable-next-line react/no-unstable-nested-components
        Cell: ({
          row: {
            original: { document },
          },
        }: any) => (
          <div className="h-12 w-12 flex items-center justify-center rounded-sm overflow-hidden shadow-sm">
            <img src={ImageFromStrapiMedia(document).uri} alt="document" />
          </div>
        ),
      },
      {
        Header: t("common.status"),
        filterName: "status$contains",
        // eslint-disable-next-line react/no-unstable-nested-components
        filterComponent: (props: any) => (
          <Select
            options={status}
            placeholder={t("common.status")}
            {...props}
          />
        ),
        className: "table-start",
        // eslint-disable-next-line react/no-unstable-nested-components
        Cell: ({
          row: {
            original: { status: s },
          },
        }: any) => <StatusBadge status={s} />,
      },
      {
        Header: t("common.actions"),
        className: "table-actions",
        // eslint-disable-next-line
        Cell: ({ row: { original } }: any) => {
          // if (!isAdmin) return null;

          return (
            <div className="flex justify-end">
              {original.status !== "accepted" ? (
                <TableValidationButton
                  onClick={() => handleValidation(original)}
                />
              ) : (
                <TableRefusalButton onClick={() => handleRefusal(original)} />
              )}

              {/* <TableEditButton onClick={() => navigate(`/user-documents/edit/${original.id}`)} /> */}
              <TableDeleteButton onClick={() => handleDelete(original.id)} />
            </div>
          );
        },
      },
    ],
    [t, handleDelete /* isAdmin */, handleRefusal, handleValidation, status]
  );

  return (
    <>
      <PageHeader
        title={t("common.userDocuments")}
        link={{ url: "/users/add", icon: "plus", label: t("common.add") }}
        subLink={{
          url: "/configure",
          icon: "arrow-left",
          label: t("common.back"),
        }}
      />
      <main className="flex-1">
        <section className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <Table
            data={items ?? []}
            columns={columns}
            isFetching={isFetching}
            pageCount={pageCount}
            filters={filters}
            setFilter={setFilter}
            setPageIndex={setPageIndex}
            itemsCount={itemsCount}
            itemsPerPage={itemsPerPage}
            pageIndex={pageIndex}
          />
        </section>
      </main>
    </>
  );
}

export default UserDocuments;
